module.exports = __webpack_public_path__ + "img/1725847669603-screenshot-1725847557758.png.91d55550.webp";